import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../../../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SchoolService } from '../../../../../services/school.service';
import { ClassService } from '../../../../../services/class.service';
import { UserStatus, UserType } from '../../../../../model/Const';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators, FormArray, UntypedFormControl } from '@angular/forms';
import { CoursewareService } from '../../../../../services/courseware.service';
import { TwNoticeService } from '../../../../../services/tw-notice.service';
import { HWResourceService } from '../../../../../services/huawei-resource.service';
import * as _ from 'lodash';
import { SyllabusService } from '../../../../../services/syllabus.service';
import { MediaV2Service } from '../../../../../services/media-v2.service';
import { TagsService } from '../../../../../services/tags.service';
import { parseInt } from 'lodash';
import { ExerciseService } from '../../../../../services/exercise.service';
import { NzUploadChangeParam, NzUploadFile } from 'ng-zorro-antd/upload';
import { HttpHeaders } from '@angular/common/http';
import { from, Subscription, throwError, EMPTY } from 'rxjs';
import * as moment from 'moment/moment';
import {
  parseDrivePathParam,
  pathIdsToDrivePathParam,
  readDrivePathIdsFromListState,
} from '../resource-drive-path.util';

@Component({
    selector: 'app-admin-resource-batch-add',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.scss'],
    standalone: false
})
export class AdminResourceItemBatchAddComponent implements OnInit {
  user: any = null;
  constUserType = UserType;
  currentSyllabusId = 0;
  currentCourseId = 0;

  isLoading = false;
  form!: UntypedFormGroup;

  syllabusList: { syllabus_id: number, course_id: number}[] = [];


  item_id = 0;
  bookAttrs: any = {};
  syllabusChildren = [];
  syllabusKeyValueItems: any = {};

  rootThemesKeyValueItems: any = {};
  subThemesKeyValueItems: any = {};

  relTags: any[] = [];
  bookInfo: any = null;
  flatSyllabusList: any[] = [];
  batchUploadFileList: NzUploadFile[] = [];
  readonly batchUploadMaxCount = 20;
  private batchOverLimitHintAt = 0;
  _tmpFormItemArray: UntypedFormGroup[] = [];

  subscription: Subscription = new Subscription();

  // 多级syllabus选择器相关属性
  multiLevelSyllabusFilters: any[] = [];

  bisType = 'cartoon';
  tabIndex = 0;
  items_status: any = {};
  // readingStatus = false;
  // classroomReadingStatus = false;

  host = '';
  protocol = '';
  bucket = '';
  exercise_items = [];

  // itemService!: CoursewareService|MediaV2Service|ExerciseService;
  itemService!: MediaV2Service;


  formatter = new Intl.NumberFormat('en', {
    minimumIntegerDigits: 2,
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
    useGrouping: false,
  });

  constructor(private userService: UserService,
              private clsService: ClassService,
              private syllabusService: SyllabusService,
              private tagsService: TagsService,
              private coursewareService: CoursewareService,
              private mediaService: MediaV2Service,
              private exerciseService: ExerciseService,
              private activatedRoute: ActivatedRoute ,
              private twNoticeService: TwNoticeService ,
              private router: Router ,
              private fb: UntypedFormBuilder,
              private uploader: HWResourceService,
              private nzMessageService: NzMessageService) {
    this.user = this.userService.getUserInfo();
    const u = new URL(window.location.href);
    this.protocol = u.protocol;
    this.host = HWResourceService.cdnHost;
    this.activatedRoute.title.subscribe({
      next: (title) => {
      }
    });
    console.log('[form] this.activatedRoute', this.activatedRoute.pathFromRoot[2].data);
    this.bisType = this.activatedRoute.pathFromRoot[2].snapshot.url[2].path;
    if (this.bisType === 'video' || this.bisType === 'audio') {
      this.itemService = this.mediaService;
    } else {
      this.nzMessageService.error('this.bisType error');
    }
    this.activatedRoute.queryParams.subscribe( (query: any) => {
      if (query.tabIndex && parseInt(query.tabIndex, 10) === query.tabIndex * 1) {
        this.tabIndex = parseInt(query.tabIndex, 10);
      }
    });
    // this.activatedRoute.queryParams.subscribe( (query: any) => {
    //   if (query.page && parseInt(query.page, 10) === query.page * 1) {
    //     this.currentPageIndex = parseInt(query.page, 10);
    //   }
    // });


    this.activatedRoute.params.subscribe( params => {
      console.log('params', params);
      this.item_id = +params['item_id'] || 0;
      this.form = this.fb.group({
        school_id: [ this.user.school_id || 0 ],
        tagsGroupArray: this.fb.array([]),
        itemsArray: this.fb.array([])
      });

    });
  }


  onVideoCoverUploadSuccess(evt: any, i: number) {
    // @ts-ignore
    this.itemsArray.controls[i].controls.cover.setValue(evt.url);
  }

  clearAudio($event: any) {
    console.log('clearAudio', $event);
    if ($event) {
      $event.preventDefault();
      $event.stopPropagation();
    }
    this.form.controls['url'].setValue(null);
  }
  onAudioUploadFailure(evt: any) {
    console.log('onAudioUploadFailure', evt);
  }
  onAudioUploadSuccess(evt: any) {
    console.log('v3/resource/batch-add onAudioUploadSuccess', evt);
    if (this.bisType === 'audio') {
      this.form.controls['url'].setValue(evt.url);
      // this.form.controls['duration'].setValue(this.formatTime(evt.file.duration / 1000));
      const time = parseInt(String(evt.file.duration / 1000), 10);
      this.form.controls['duration'].setValue(time);
      this.form.controls['size'].setValue(evt.file.size);
    }
  }

  getFileSuffix(url: string) {
    const lastDotIndex = (url || '').lastIndexOf('.');
    const suffix = lastDotIndex !== -1 ? url.substring(lastDotIndex + 1) : '';
    return suffix;
  }

  formatTime(time: number) {
    time = parseInt(String(time), 10);
    const sec = time % 60;
    const min = Math.floor(time / 60);
    const hour = Math.floor(time / (60 * 60));
    let t = `${min}:${sec}`;
    if (hour) {
      t = `${hour}:${t}`;
    }
    return t;
  }




  get tagsGroupArray() {
    return this.form.get('tagsGroupArray') as FormArray;
  }
  get itemsArray () {
    return (this.form.get('itemsArray') || []) as FormArray;
  }

  addTagsGroup({syllabus_id = 0, course_id = 0}: {syllabus_id?: number, course_id?: number, tags?: any[]}) {
    console.log('[添加] 添加标签组:', syllabus_id, course_id);

    // 确保multiLevelSyllabusFilters已经初始化
    if (!this.multiLevelSyllabusFilters || this.multiLevelSyllabusFilters.length === 0) {
      this.initializeMultiLevelSyllabusFilters();
    }

    const tagFb = this.fb.group({
      syllabus_id: this.fb.control(+syllabus_id, Validators.required),
      course_id: this.fb.control(+course_id, Validators.required),
    });

    // 计算最大深度并添加表单控件
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const startLevel = 2; // 从第三级开始
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1

    // 为多级选择器添加表单控件（基于最大深度）
    for (let i = startLevel; i < endLevel; i++) {
      tagFb.addControl(`level_${i}`, this.fb.control(null));
    }

    this.tagsGroupArray.push(tagFb);

    // 添加表单值变化监听器
    const groupIndex = this.tagsGroupArray.length - 1;
    this.setupFormValueListeners(groupIndex, tagFb);

    console.log('[添加] 标签组添加完成，当前总数:', this.tagsGroupArray.length);
  }

  /**
   * 设置表单值变化监听器
   * @param groupIndex 分组索引
   * @param formGroup 表单组
   */
  setupFormValueListeners(groupIndex: number, formGroup: FormGroup) {
    // 监听一级分类变化
    formGroup.get('syllabus_id')?.valueChanges.subscribe(value => {
      console.log('[监听] 一级分类值变化:', groupIndex, value);
      this.changeSyllabusInternal(groupIndex, value);
    });

    // 监听二级大纲变化
    formGroup.get('course_id')?.valueChanges.subscribe(value => {
      console.log('[监听] 二级大纲值变化:', groupIndex, value);
      this.changeCourseInternal(groupIndex, value);
    });

    // 监听多级选择器变化
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const startLevel = 2;
    const endLevel = maxDepth;

    for (let i = startLevel; i < endLevel; i++) {
      formGroup.get(`level_${i}`)?.valueChanges.subscribe(value => {
        console.log(`[监听] 层级${i}值变化:`, groupIndex, value);
        this.changeMultiLevelSyllabusInternal(groupIndex, i, value);
      });
    }
  }

  removeTagsGroup(index: number): void {
    console.log('[删除] 删除标签组:', index);
    this.tagsGroupArray.removeAt(index);
  }

  clearTagsField({prefix = '', parent = null}: {prefix?: string, parent?: FormGroup|null}) {
    if (!parent) {
      parent = this.form;
    }
    const keys = Object.keys(parent.controls);
    for (let i = 0; i < keys.length; i++) {
      if (keys[i].startsWith(`${prefix}.`)) {
        parent.removeControl(keys[i]);
      }
    }
  }

  addTagsField({id, value = null, prefix = '', parent = null}: {id: any, value?: any, prefix?: string,  parent?: FormGroup|null}): void {
    if (!parent) {
      parent = this.form;
    }
    const tagsControl = [];
    parent.addControl(
      `${prefix}.` + id,
      new UntypedFormControl(value)
    );
  }

  flattenTree(tree: any): any {
    if (!tree || !Array.isArray(tree)) {
      return [];
    }

    return _.flatMap(tree, (node) => {
      const { children, ...rest } = node;
      return [rest, ...this.flattenTree(children || [])];
    });
  }

  findParentTag(targetList: any, id: any) {
    if (!targetList || !Array.isArray(targetList)) {
      return null;
    }

    for (let i = 0; i < targetList.length; i++) {
      const target = targetList[i];
      const find = target.children?.find((child: any) => +child.id === +id);
      if (find) {
        return target;
      }
    }

    return null;
  }

  currentSubOptions (group_index: number) {
    if (group_index >= this.tagsGroupArray.controls.length) {
      return [];
    }

    const group = this.tagsGroupArray.controls[group_index] as FormGroup;
    const syllabus_id = group.controls['syllabus_id']?.value;

    if (!syllabus_id || !this.bookAttrs.syllabus) {
      return [];
    }

    const item = this.bookAttrs.syllabus.find((s: any) => {
      return +s.id === +syllabus_id;
    });
    return item?.children || [];
  }

  // 添加标志位来避免递归
  private isProcessingChange = false;

  /**
   * 内部方法：处理一级分类变化（避免递归）
   */
  changeSyllabusInternal(group_index: number, syllabus_id: number) {
    if (this.isProcessingChange) {
      console.log('[内部] 跳过递归调用');
      return;
    }

    this.isProcessingChange = true;
    console.log('[内部] 一级分类变化:', group_index, syllabus_id);

    if (!(+syllabus_id)) {
      this.isProcessingChange = false;
      return;
    }

    if (group_index >= this.tagsGroupArray.controls.length) {
      this.isProcessingChange = false;
      return;
    }

    const group = (this.tagsGroupArray.controls[group_index] as FormGroup);

    // 重置第二级（大纲）选择
    const courseIdControl = group.controls['course_id'];
    if (courseIdControl) {
      courseIdControl.reset(-1);
      console.log('[重置] 二级大纲已重置为-1');
    }

    // 清除相关的标签字段
    this.clearTagsField({prefix: 'tag_group_id', parent: group});
    this.clearTagsField({prefix: 'tag_id', parent: group});

    if (typeof syllabus_id === 'undefined') {
      this.currentSyllabusId = 0;
      this.currentCourseId = 0;
      this.syllabusChildren = [];
      this.isProcessingChange = false;
      return;
    }

    this.currentSyllabusId = syllabus_id;
    const selectedTags = this.rootThemesKeyValueItems[syllabus_id] || [];
    const tags = this.bookAttrs.themes?.filter((tag: any) => +tag.syllabus_id === +syllabus_id) || [];

    tags.forEach((tag: any) => {
      this.addTagsField({
        id: tag.id,
        value: null,
        prefix: 'tag_group_id',
        parent: group});
    });

    setTimeout(() => {
      this.tagsGroupArray.updateValueAndValidity();
      console.log('[重置] UI更新完成');
      this.isProcessingChange = false;
    }, 0);
  }

  changeSyllabus(group_index: number, syllabus_id: number) {
    console.log('[重置] 一级分类变化:', group_index, syllabus_id);

    if (!(+syllabus_id)) {
      return;
    }

    if (group_index >= this.tagsGroupArray.controls.length) {
      return;
    }

    const group = (this.tagsGroupArray.controls[group_index] as FormGroup);

    // 重置第二级（大纲）选择
    const courseIdControl = group.controls['course_id'];
    if (courseIdControl) {
      courseIdControl.reset(-1);
      console.log('[重置] 二级大纲已重置为-1');
    }

    // 清除相关的标签字段
    this.clearTagsField({prefix: 'tag_group_id', parent: group});
    this.clearTagsField({prefix: 'tag_id', parent: group});

    if (typeof syllabus_id === 'undefined') {
      this.currentSyllabusId = 0;
      this.currentCourseId = 0;
      this.syllabusChildren = [];
      return;
    }

    this.currentSyllabusId = syllabus_id;
    const selectedTags = this.rootThemesKeyValueItems[syllabus_id] || [];
    const tags = this.bookAttrs.themes?.filter((tag: any) => +tag.syllabus_id === +syllabus_id) || [];

    tags.forEach((tag: any) => {
      this.addTagsField({
        id: tag.id,
        value: null,
        prefix: 'tag_group_id',
        parent: group});
    });

    setTimeout(() => {
      this.tagsGroupArray.updateValueAndValidity();
      console.log('[重置] UI更新完成');
    }, 0);
  }

  /**
   * 内部方法：处理二级大纲变化（避免递归）
   */
  changeCourseInternal(group_index: number, course_id: number) {
    if (this.isProcessingChange) {
      console.log('[内部] 跳过递归调用');
      return;
    }

    this.isProcessingChange = true;
    console.log('[内部] 二级大纲变化:', group_index, course_id);

    if (group_index >= this.tagsGroupArray.controls.length) {
      this.isProcessingChange = false;
      return;
    }

    const group = this.tagsGroupArray.controls[group_index] as FormGroup;
    if (!group) {
      this.isProcessingChange = false;
      return;
    }

    if (!(+course_id) || !course_id) {
      this.currentCourseId = 0;
      console.log('[重置] 二级大纲无效，已重置后续选择');
      this.isProcessingChange = false;
      return;
    }

    const courseIdControl = group.controls['course_id'];
    if (courseIdControl) {
      courseIdControl.setValue(+course_id, {emitViewToModelChange: false});
    }

    // 清除第三级及以后相关的标签字段
    this.clearTagsField({prefix: 'tag_id', parent: group});

    this.currentCourseId = course_id;
    const selectedTags = this.subThemesKeyValueItems[course_id] || [];
    const tags = this.bookAttrs.themes?.filter((tag: any) => +tag.syllabus_id === +course_id) || [];
    tags.forEach((tag: any) => {
      this.addTagsField({
        value: null,
        id: tag.id,
        prefix: 'tag_id',
        parent: group});
    });

    setTimeout(() => {
      this.tagsGroupArray.updateValueAndValidity();
      console.log('[重置] UI更新完成');
      this.isProcessingChange = false;
    }, 0);
  }

  changeCourse(group_index: number, course_id: number) {
    console.log('[重置] 二级大纲变化:', group_index, course_id);

    if (group_index >= this.tagsGroupArray.controls.length) {
      return;
    }

    const group = this.tagsGroupArray.controls[group_index] as FormGroup;
    if (!group) {
      return;
    }

    if (!(+course_id) || !course_id) {
      this.currentCourseId = 0;
      console.log('[重置] 二级大纲无效，已重置后续选择');
      return;
    }

    const courseIdControl = group.controls['course_id'];
    if (courseIdControl) {
      courseIdControl.setValue(+course_id, {emitViewToModelChange: false});
    }

    // 清除第三级及以后相关的标签字段
    this.clearTagsField({prefix: 'tag_id', parent: group});

    this.currentCourseId = course_id;
    const selectedTags = this.subThemesKeyValueItems[course_id] || [];
    const tags = this.bookAttrs.themes?.filter((tag: any) => +tag.syllabus_id === +course_id) || [];
    tags.forEach((tag: any) => {
      this.addTagsField({
        value: null,
        id: tag.id,
        prefix: 'tag_id',
        parent: group});
    });

    setTimeout(() => {
      this.tagsGroupArray.updateValueAndValidity();
      console.log('[重置] UI更新完成');
    }, 0);
  }

  /**
   * 构建path字符串
   * @param groupIndex 分组索引
   * @returns path字符串
   */
  buildPath(groupIndex: number): string {
    if (groupIndex >= this.tagsGroupArray.controls.length) {
      return '';
    }

    const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
    if (!group) {
      return '';
    }

    const pathParts: string[] = [];

    // 添加第一级（分类）
    const syllabusId = group.controls['syllabus_id']?.value;
    if (syllabusId && syllabusId > 0) {
      pathParts.push(syllabusId.toString());
    }

    // 添加第二级（大纲）
    const courseId = group.controls['course_id']?.value;
    if (courseId && courseId > 0) {
      pathParts.push(courseId.toString());
    }

    // 计算最大深度
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const startLevel = 2; // 从第三级开始
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1

    // 添加第三级及以后的ID
    for (let i = startLevel; i < endLevel; i++) {
      const levelValue = group.controls[`level_${i}`]?.value;
      if (levelValue && levelValue > 0) {
        pathParts.push(levelValue.toString());
      } else {
        break; // 如果某个层级没有值，停止添加
      }
    }

    return pathParts.join('/');
  }

  /**
   * 计算syllabus树的最大深度
   * @param nodes 节点数组
   * @param currentDepth 当前深度
   * @returns 最大深度
   */
  getMaxDepth(nodes: any[], currentDepth: number = 1): number {
    if (!nodes || !Array.isArray(nodes) || nodes.length === 0) {
      return currentDepth - 1;
    }

    let maxDepth = currentDepth;

    for (const node of nodes) {
      if (node.children && Array.isArray(node.children) && node.children.length > 0) {
        const childDepth = this.getMaxDepth(node.children, currentDepth + 1);
        maxDepth = Math.max(maxDepth, childDepth);
      }
    }

    return maxDepth;
  }

  /**
   * 初始化多级syllabus选择器
   */
  initializeMultiLevelSyllabusFilters() {
    this.multiLevelSyllabusFilters = [];

    // 计算syllabus树的最大深度
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    console.log('[初始化] syllabus树最大深度:', maxDepth);

    // 动态添加第三级及以后的层级（基于最大深度）
    const startLevel = 2; // 从第三级开始
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1

    for (let i = startLevel; i < endLevel; i++) {
      this.multiLevelSyllabusFilters.push({
        level: i,
        name: `级别${i + 1}`,
        field: `level_${i}`,
        options: [],
        placeholder: `级别${i + 1}`
      });
    }

    console.log('[初始化] 多级选择器初始化完成，数量:', this.multiLevelSyllabusFilters.length);
  }

  /**
   * 判断是否应该显示某个层级的选择器
   * @param groupIndex 分组索引
   * @param level 层级
   * @returns 是否显示
   */
  shouldShowLevelSelector(groupIndex: number, level: number): boolean {
    // 如果multiLevelSyllabusFilters还没有初始化，不显示
    if (!this.multiLevelSyllabusFilters || this.multiLevelSyllabusFilters.length === 0) {
      return false;
    }

    // 只有音频和视频资源才显示多级选择器
    if (this.bisType !== 'audio' && this.bisType !== 'video') {
      return false;
    }

    if (groupIndex >= this.tagsGroupArray.controls.length) {
      return false;
    }

    const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
    if (!group) {
      return false;
    }

    const courseId = group.controls['course_id']?.value;

    // 如果第二级（大纲）没有选择或为-1，不显示第三级及以后的选择器
    if (!courseId || courseId <= 0) {
      return false;
    }

    // 检查当前层级的表单控件是否存在
    const levelControl = group.controls[`level_${level}`];
    if (!levelControl) {
      return false;
    }

    // 对于第三级，只要有第二级选择就显示
    if (level === 2) {
      const options = this.getMultiLevelSyllabusOptions(groupIndex, level);
      return options && options.length > 0;
    }

    // 对于第四级及以后，需要检查上一级是否有选择
    if (level > 2) {
      const parentLevel = level - 1;
      const parentValue = group.controls[`level_${parentLevel}`]?.value;
      if (!parentValue || parentValue <= 0) {
        return false;
      }
    }

    // 检查当前层级是否有选项
    const options = this.getMultiLevelSyllabusOptions(groupIndex, level);
    return options && options.length > 0;
  }

  /**
   * 获取多级syllabus选择器的选项
   * @param groupIndex 分组索引
   * @param level 层级
   * @returns 选项数组
   */
  getMultiLevelSyllabusOptions(groupIndex: number, level: number): any[] {
    // 如果multiLevelSyllabusFilters还没有初始化，返回空数组
    if (!this.multiLevelSyllabusFilters || this.multiLevelSyllabusFilters.length === 0) {
      return [];
    }

    // 只有音频和视频资源才返回多级选择器选项
    if (this.bisType !== 'audio' && this.bisType !== 'video') {
      return [];
    }

    if (groupIndex >= this.tagsGroupArray.controls.length) {
      return [];
    }

    const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
    if (!group) {
      return [];
    }

    // 计算最大深度
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const startLevel = 2; // 从第三级开始
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1

    if (level === 2) {
      // 第三级：基于第二级（大纲）的选择
      const courseId = group.controls['course_id']?.value;
      if (!courseId || courseId <= 0) {
        return [];
      }
      return this.getChildrenByParentId(courseId);
    } else if (level > 2 && level < endLevel) {
      // 第四级及以后：基于上一级的选择
      const parentLevel = level - 1;
      const parentValue = group.controls[`level_${parentLevel}`]?.value;
      if (!parentValue || parentValue <= 0) {
        return [];
      }
      return this.getChildrenByParentId(parentValue);
    }

    return [];
  }

  /**
   * 根据父节点ID获取子节点
   * @param parentId 父节点ID
   * @returns 子节点数组
   */
  getChildrenByParentId(parentId: number): any[] {
    if (!parentId || !this.bookAttrs.syllabus || !Array.isArray(this.bookAttrs.syllabus)) {
      return [];
    }

    // 从syllabus树形结构中查找子节点
    const findChildren = (nodes: any[], parentId: number): any[] => {
      for (const node of nodes) {
        if (node.id === parentId && node.children) {
          return node.children;
        }
        if (node.children) {
          const result = findChildren(node.children, parentId);
          if (result.length > 0) {
            return result;
          }
        }
      }
      return [];
    };

    return findChildren(this.bookAttrs.syllabus, parentId);
  }

  /**
   * 内部方法：处理多级syllabus选择变化（避免递归）
   */
  changeMultiLevelSyllabusInternal(groupIndex: number, level: number, value: number) {
    if (this.isProcessingChange) {
      console.log('[内部] 跳过递归调用');
      return;
    }

    this.isProcessingChange = true;
    console.log(`[内部] 层级${level}变化:`, groupIndex, value);

    // 如果multiLevelSyllabusFilters还没有初始化，不执行
    if (!this.multiLevelSyllabusFilters || this.multiLevelSyllabusFilters.length === 0) {
      this.isProcessingChange = false;
      return;
    }

    if (groupIndex >= this.tagsGroupArray.controls.length) {
      this.isProcessingChange = false;
      return;
    }

    const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
    if (!group) {
      this.isProcessingChange = false;
      return;
    }

    // 设置当前层级的值
    const levelControl = group.controls[`level_${level}`];
    if (levelControl) {
      levelControl.setValue(value);
    }

    // 重置后续层级的所有选择
    this.resetLevelsFrom(groupIndex, level + 1);

    // 更新层级名称
    this.updateMultiLevelName(groupIndex, level, value);

    // 检查下一级是否有选项，如果有则确保下一级控件存在
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1
    const nextLevel = level + 1;
    if (nextLevel < endLevel) {
      const nextLevelOptions = this.getMultiLevelSyllabusOptions(groupIndex, nextLevel);
      if (nextLevelOptions && nextLevelOptions.length > 0) {
        // 确保下一级控件存在
        if (!group.controls[`level_${nextLevel}`]) {
          group.addControl(`level_${nextLevel}`, this.fb.control(null));
          console.log(`[多级] 动态添加控件 level_${nextLevel}`);
        }
      }
    }

    // 强制触发变更检测，确保下一级选择器能够正确显示
    setTimeout(() => {
      // 触发变更检测
      this.tagsGroupArray.updateValueAndValidity();
      console.log(`[多级] UI更新完成`);
      this.isProcessingChange = false;
    }, 0);
  }

  /**
   * 处理多级syllabus选择变化
   * @param groupIndex 分组索引
   * @param level 层级
   * @param value 选中的值
   */
  changeMultiLevelSyllabus(groupIndex: number, level: number, value: number) {
    console.log(`[多级] 层级${level}变化:`, groupIndex, value);

    // 如果multiLevelSyllabusFilters还没有初始化，不执行
    if (!this.multiLevelSyllabusFilters || this.multiLevelSyllabusFilters.length === 0) {
      return;
    }

    if (groupIndex >= this.tagsGroupArray.controls.length) {
      return;
    }

    const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
    if (!group) {
      return;
    }

    // 设置当前层级的值
    const levelControl = group.controls[`level_${level}`];
    if (levelControl) {
      levelControl.setValue(value);
    }

    // 重置后续层级的所有选择
    this.resetLevelsFrom(groupIndex, level + 1);

    // 更新层级名称
    this.updateMultiLevelName(groupIndex, level, value);

    // 检查下一级是否有选项，如果有则确保下一级控件存在
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1
    const nextLevel = level + 1;
    if (nextLevel < endLevel) {
      const nextLevelOptions = this.getMultiLevelSyllabusOptions(groupIndex, nextLevel);
      if (nextLevelOptions && nextLevelOptions.length > 0) {
        // 确保下一级控件存在
        if (!group.controls[`level_${nextLevel}`]) {
          group.addControl(`level_${nextLevel}`, this.fb.control(null));
          console.log(`[多级] 动态添加控件 level_${nextLevel}`);
        }
      }
    }

    // 强制触发变更检测，确保下一级选择器能够正确显示
    setTimeout(() => {
      // 触发变更检测
      this.tagsGroupArray.updateValueAndValidity();
      console.log(`[多级] UI更新完成`);
    }, 0);
  }

  /**
   * 重置指定层级及以后的所有选择
   * @param groupIndex 分组索引
   * @param fromLevel 从哪个层级开始重置
   */
  resetLevelsFrom(groupIndex: number, fromLevel: number) {
    if (groupIndex >= this.tagsGroupArray.controls.length) {
      return;
    }

    const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
    if (!group) {
      return;
    }

    // 计算最大深度
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1

    console.log(`[重置] 重置层级 ${fromLevel} 到 ${endLevel}`);

    // 清除从指定层级开始的所有选择
    for (let i = fromLevel; i < endLevel; i++) {
      const levelControl = group.controls[`level_${i}`];
      if (levelControl) {
        levelControl.setValue(null);
        console.log(`[重置] 层级 ${i} 已重置为null`);
      }
    }

    // 清除相关的标签字段
    if (fromLevel === 2) {
      // 如果从第三级开始重置，清除第二级相关的标签字段
      this.clearTagsField({prefix: 'tag_group_id', parent: group});
      console.log('[重置] 已清除tag_group_id字段');
    }
    // 清除第三级及以后相关的标签字段
    this.clearTagsField({prefix: 'tag_id', parent: group});
    console.log('[重置] 已清除tag_id字段');
  }

  /**
   * 根据选中的父节点更新子节点的名称
   * @param groupIndex 分组索引
   * @param level 当前层级
   * @param selectedValue 选中的值
   */
  updateMultiLevelName(groupIndex: number, level: number, selectedValue: number) {
    // 计算最大深度
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const startLevel = 2; // 从第三级开始
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1

    if (level >= endLevel - 1 || !this.bookAttrs.syllabus) {
      return;
    }

    // 查找选中的节点
    const selectedNode = this.findNodeById(this.bookAttrs.syllabus, selectedValue);
    if (selectedNode && selectedNode.children && selectedNode.children.length > 0) {
      // 如果选中的节点有子节点，更新下一级的名称
      const nextLevel = level + 1;
      if (nextLevel < endLevel && nextLevel < this.multiLevelSyllabusFilters.length) {
        // 尝试从子节点的第一个元素获取层级名称
        const firstChild = selectedNode.children[0];
        if (firstChild && firstChild.level_name) {
          this.multiLevelSyllabusFilters[nextLevel].name = firstChild.level_name;
          this.multiLevelSyllabusFilters[nextLevel].placeholder = firstChild.level_name;
        } else {
          // 如果没有level_name，使用默认名称
          this.multiLevelSyllabusFilters[nextLevel].name = `级别${nextLevel + 1}`;
          this.multiLevelSyllabusFilters[nextLevel].placeholder = `级别${nextLevel + 1}`;
        }
      }
    }
  }

  /**
   * 根据ID查找节点
   * @param nodes 节点数组
   * @param id 要查找的ID
   * @returns 找到的节点或null
   */
  findNodeById(nodes: any[], id: number): any {
    if (!nodes || !Array.isArray(nodes)) {
      return null;
    }

    for (const node of nodes) {
      if (node.id === id) {
        return node;
      }
      if (node.children) {
        const result = this.findNodeById(node.children, id);
        if (result) {
          return result;
        }
      }
    }
    return null;
  }

  /**
   * 获取当前选择路径的实际深度
   * @param groupIndex 分组索引
   * @returns 实际深度
   */
  getActualSelectionDepth(groupIndex: number): number {
    if (groupIndex >= this.tagsGroupArray.controls.length) {
      return 2; // 默认只有两级
    }

    const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
    if (!group) {
      return 2;
    }

    // 检查第一级和第二级是否已选择
    const syllabusId = group.controls['syllabus_id']?.value;
    const courseId = group.controls['course_id']?.value;

    if (!syllabusId || syllabusId <= 0) {
      return 0; // 第一级未选择
    }

    if (!courseId || courseId <= 0) {
      return 1; // 只有第一级
    }

    // 计算最大深度
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const startLevel = 2; // 从第三级开始
    const endLevel = maxDepth; // 直接使用最大深度，不需要减1

    // 从第三级开始检查，找到最后一个有选项的层级
    let actualDepth = 2; // 默认深度为2（第一级和第二级）

    for (let i = startLevel; i < endLevel; i++) {
      // 检查该层级是否有选项可显示
      const options = this.getMultiLevelSyllabusOptions(groupIndex, i);
      if (options && options.length > 0) {
        actualDepth = i + 1; // 更新实际深度
      } else {
        // 如果没有选项，说明已经到达叶子节点
        break;
      }
    }

    console.log(`getActualSelectionDepth: groupIndex=${groupIndex}, actualDepth=${actualDepth}`);
    return actualDepth;
  }

  get titleName() {
    let title = '';
    if (this.bisType === 'cartoon') {
      title = '绘本';
    } else if (this.bisType === 'book') {
      title = '绘本';
    } else if (this.bisType === 'audio') {
      title = '音频';
    } else if (this.bisType === 'video') {
      title = '视频';
    } else if (this.bisType === 'exercise') {
      title = '练习';
    }
    return title;
  }
  get actionName() {
    let action = '新增';
    if (this.item_id) {
      action = '编辑';
    }
    return action;
  }
  get backUrl () {
    return `/admin/v3/resource/${this.bisType}/list`;
  }

  private resolveInitialDrivePath(): string | null {
    const pathParam = this.activatedRoute.snapshot.queryParamMap.get('path');
    if (pathParam?.trim()) {
      return pathParam.trim();
    }
    const pathIds = readDrivePathIdsFromListState(this.bisType);
    return pathIdsToDrivePathParam(pathIds);
  }

  private parsePath(path: string) {
    return parseDrivePathParam(path);
  }

  private applyInitialDrivePath(): void {
    if (this.tagsGroupArray.length > 0) {
      return;
    }
    const path = this.resolveInitialDrivePath();
    if (!path) {
      return;
    }
    const pathData = this.parsePath(path);
    if (!pathData.syllabus_id) {
      return;
    }
    const syllabus_id = pathData.syllabus_id;
    const course_id = pathData.course_id ?? 0;
    this.addTagsGroup({ syllabus_id, course_id });
    this.changeSyllabus(0, syllabus_id);
    if (course_id > 0) {
      this.changeCourse(0, course_id);
    }
    const group = this.tagsGroupArray.controls[0] as FormGroup;
    const maxDepth = this.getMaxDepth(this.bookAttrs.syllabus || []);
    const startLevel = 2;
    for (let level = startLevel; level < maxDepth; level++) {
      const levelValue = pathData.levels[`level_${level}`];
      if (!levelValue) {
        continue;
      }
      const levelControl = group.controls[`level_${level}`];
      if (levelControl) {
        levelControl.setValue(levelValue);
        this.updateMultiLevelName(0, level, levelValue);
      }
    }
  }

  ngOnInit() {
    this.isLoading = true;
    // 获取syllabus数据
    this.syllabusService.category(this.bisType).then((bookAttrs) => {
      console.log('bookAttrs', bookAttrs);
      const _themesKeyValueItems = _.groupBy(bookAttrs.themes || [], 'syllabus_id');
      this.flatSyllabusList = this.flattenTree(bookAttrs.syllabus || []);
      if (this.flatSyllabusList && this.flatSyllabusList.length > 0) {
        this.flatSyllabusList.forEach((syllabus: any) => {
          if (typeof syllabus.path === 'string') {
            const pathParts = syllabus.path.split('/');
            syllabus.path_parts = [ ...pathParts.filter((p: string) => p.trim()).map((path: any) => +path), syllabus.id];
          }
        });
      }

      this.rootThemesKeyValueItems = _.groupBy(bookAttrs.themes || [], 'syllabus_id');
      this.subThemesKeyValueItems = _themesKeyValueItems || {};
      this.syllabusKeyValueItems = _.keyBy(this.flatSyllabusList || [], 'id');

      this.bookAttrs = bookAttrs || {};

      // 初始化多级syllabus选择器
      this.initializeMultiLevelSyllabusFilters();
      this.applyInitialDrivePath();

      this.isLoading = false;
    }).catch(err => {
      this.isLoading = false;
      this.nzMessageService.error(err.message || 'System Error');
    });
  }




  tabIndexChange($evt: any) {
    console.log('tabIndexChange', $evt, this.tabIndex);
    this.tabIndex = $evt;
  }
  noticeReadingStatus() {
    this.twNoticeService.warning({nzContent: '請先上傳Reading素材'});
  }
  setCover(event: any, i: number) {
    console.log('changeCover', event, i );
    // @ts-ignore
    this.itemsArray.controls[i].controls.cover.setValue(event.url);
    // this.form.controls['cover'].setValue(event.url);
    // this.form.controls['itemsArray'][i].controls['cover'].setValue(event.url);
  }

  submitForm = ($event: any, value: any) => {
    if ($event) {
      $event.preventDefault();
    }
    if (this.isLoading) {
      return;
    }
    for (const key in this.form.controls) {
      this.form.controls[ key ].markAsDirty();
      this.form.controls[ key ].updateValueAndValidity();
    }

    let tagValid = true;
    value.tagsGroupArray.forEach((tag: any, groupIndex: number) => {
      const {course_id, syllabus_id} = tag;
      if (course_id <= 0 || syllabus_id < 0) {
        tagValid = false;
      }

      // 验证多级选择器的必填字段
      const group = this.tagsGroupArray.controls[groupIndex] as FormGroup;
      if (group) {
        // 获取当前选择路径的实际深度
        const actualDepth = this.getActualSelectionDepth(groupIndex);
        const startLevel = 2; // 从第三级开始

        // 只验证到实际深度
        for (let i = startLevel; i < actualDepth; i++) {
          const levelControl = group.controls[`level_${i}`];
          if (levelControl && this.shouldShowLevelSelector(groupIndex, i)) {
            // 如果该层级应该显示，则检查是否已选择
            const levelValue = levelControl.value;
            if (!levelValue || levelValue <= 0) {
              tagValid = false;
              console.log(`多级选择器验证失败: level_${i} 未选择`);
            }
          }
        }
      }
    });

    if (!tagValid || !value.tagsGroupArray || (Array.isArray(value.tagsGroupArray) && value.tagsGroupArray.length === 0)) {
      this.nzMessageService.error('请正确关联分类');
      return;
    }

    if (!Array.isArray(value.itemsArray) || value.itemsArray.length > this.batchUploadMaxCount) {
      this.nzMessageService.error('一次最多保存 20 条');
      return;
    }

    // 为每个分组构建path字段
    value.tagsGroupArray.forEach((tagGroup: any, index: number) => {
      tagGroup.path = this.buildPath(index);
    });

    this.isLoading = true;
    console.log('submitForm', $event, value);
    this.itemService.batchSave(this.bisType, value).then((result) => {
      this.isLoading = false;
      const modal = this.twNoticeService.success({nzContent: '保存成功'});
      modal.afterClose.subscribe(() => {
        if (!this.item_id) {
          this.router.navigate([`/admin/v3/resource/${this.bisType}`]);
        }

      });
    }).catch(err => {
      this.isLoading = false;
      this.nzMessageService.error(err.message || 'System Error');
    });
  }

  resetForm(e: MouseEvent): void {
    e.preventDefault();
    this.form.reset();
    for (const key in this.form.controls) {
      this.form.controls[ key ].markAsPristine();
      this.form.controls[ key ].updateValueAndValidity();
    }
  }

  dragStart($evt: any) {
    console.log('dragStart', $evt);
  }
  dragging($evt: any) {
    console.log('dragging', $evt);
  }

  reloadData() {
    this.ngOnInit();
  }

  genUid(str: string) {
      const encoder = new TextEncoder();
      const data = encoder.encode(str);
      let binary = '';
      for (const byte of data) {
        binary += String.fromCharCode(byte);
      }
      return btoa(binary);

  }
  private mediaFileKey(file: { name?: string; lastModified?: string | number; size?: number }): string {
    return `${file.name}|${file.lastModified}|${file.size}`;
  }

  private showBatchOverLimitHint(): void {
    const now = Date.now();
    if (now - this.batchOverLimitHintAt < 300) {
      return;
    }
    this.batchOverLimitHintAt = now;
    this.nzMessageService.error('最多同时处理 20 个文件');
  }

  private isBatchUploadOccupied(file: NzUploadFile, currentBatchKeys: Set<string>): boolean {
    const uid = this.genUid(this.mediaFileKey(file));
    const inUploading = this.batchUploadFileList.some((f: NzUploadFile) => {
      return f.uid === uid && !currentBatchKeys.has(this.mediaFileKey(f));
    });
    const inForm = this.itemsArray.controls.some((c) => {
      // @ts-ignore
      return uid === c.controls.uid.value;
    });
    return inUploading || inForm;
  }

  beforeBatchUpload = (file: NzUploadFile, fileList ?: NzUploadFile[]) => {
    console.log('beforeBatchUpload', file, fileList);
    const key = this.mediaFileKey(file);
    // @ts-ignore
    file.uniqueId = this.genUid(key);
    file.uid = this.genUid(key);

    const batch = fileList && fileList.length ? fileList : [file];
    const batchKeys = new Set(batch.map((f) => this.mediaFileKey(f)));

    if (this.isBatchUploadOccupied(file, batchKeys)) {
      this.nzMessageService.warning(`${file.name} already exists!`);
      return false;
    }

    const occupied = this.itemsArray.length + this.batchUploadFileList.filter(
      (f) => !batchKeys.has(this.mediaFileKey(f))
    ).length;

    const uniqueNew: NzUploadFile[] = [];
    batch.forEach((f) => {
      if (this.isBatchUploadOccupied(f, batchKeys)) {
        return;
      }
      const k = this.mediaFileKey(f);
      if (uniqueNew.some((item) => this.mediaFileKey(item) === k)) {
        return;
      }
      uniqueNew.push(f);
    });

    const idx = uniqueNew.findIndex((f) => this.mediaFileKey(f) === key);
    if (idx < 0) {
      return false;
    }

    if (occupied + idx >= this.batchUploadMaxCount) {
      this.showBatchOverLimitHint();
      return false;
    }
    return true;
  }

  getFileType(file: NzUploadFile): string {
    const extension = file.name.split('.').pop()?.toLowerCase();
    // @ts-ignore
    if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) { return 'image'; }
    if (extension === 'pdf') { return 'pdf'; }
    // @ts-ignore
    if (['xls', 'xlsx'].includes(extension)) { return 'excel'; }
    return 'other';
  }

  isPreviewable(file: NzUploadFile): boolean {
    const type = this.getFileType(file);
    return type === 'image' || type === 'pdf';
  }

  previewFile(file: NzUploadFile): void {
    // 实现预览逻辑
  }
  removeFile(file: NzUploadFile): void {
    console.log('removeFile',  this.batchUploadFileList);
    // 通过uid过滤掉要删除的文件
    this.batchUploadFileList = this.batchUploadFileList.filter(item => item.uid !== file.uid);
  }
  moveUploadFile(index: number, direction: -1 | 1): void {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= this.batchUploadFileList.length) {
      return;
    }
    const list = [...this.batchUploadFileList];
    [list[index], list[newIndex]] = [list[newIndex], list[index]];
    this.batchUploadFileList = list;
  }
  moveItemByIndex(index: number, direction: -1 | 1): void {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= this.itemsArray.length) {
      return;
    }
    const item = this.itemsArray.at(index);
    this.itemsArray.removeAt(index);
    this.itemsArray.insert(newIndex, item);
    const tmpItem = this._tmpFormItemArray.splice(index, 1)[0];
    this._tmpFormItemArray.splice(newIndex, 0, tmpItem);
  }
  removeFileByIndex(index: number): void {
    console.log('removeFileByIndex',  index);
    this.itemsArray.removeAt(index);
    this._tmpFormItemArray.splice(index, 1);
  }

  customUploadRequest = (options: any): Subscription => {
    const { file, onSuccess, onError, onProgress } = options;


    // this.bisType === 'video'
    if (this.bisType === 'video' && !file.name.toLowerCase().endsWith('.mp4')) {
      const error = new Error('文件不是mp4');
      file.error = error;
      this.nzMessageService.error(`${file.name} 不是mp4文件`);
      return new Subscription();
    }

    if (this.bisType === 'audio' && !file.name.toLowerCase().endsWith('.mp3')) {
      const error = new Error('文件不是mp3');
      file.error = error;
      this.nzMessageService.error(`${file.name} 不是mp3文件`);
      return new Subscription();
    }

    console.log('customUploadRequest', file.uniqueId );

    const that = this;
    return from(this.uploader.asyncDoUpload({
      file,
      // osspath: 'debug/v1',
      osspath: '',
      progress_cb: onProgress,
      success_cb: async ({name, hash, url, file: f}) => {
        let duration = 0;
        try {
          duration = await that.getMediaFileDuration(url);
          f.duration = duration;
          onSuccess({name, hash, url, file: f, duration});
        } catch (err) {
          f.error = err;
          onError(err);
        }

      },
      error_cb: onError}))
      .subscribe({
        next: (response) => {
          console.log('Data loaded', response);
        },
        error: (error) => {
          console.error('Error loading data', error);
          // @ts-ignore
          const { file: f } = error;
          if (f) {
            f.error = error;
          }
          onError(error);
        }
      });
  }

  convertTimeToTag(time: number, options: {h: boolean, ms: boolean}): string {
    if (time === undefined) {
      return '';
    }
    const r = moment.utc(time * 1000).format('HH:mm:ss');
    return r;
  }

  handleChange({ file, fileList }: NzUploadChangeParam): void {
    console.log('handleChange', file, fileList);
    const status = file.status;
    if (status !== 'uploading') {
      console.log('handleChange', status, file, fileList);
    }
    if (status === 'done') {
      const fname = file.name || file.response.name;
      const n = fname.substr(0, fname.lastIndexOf('.'));
      const fields = {
        // school_id: this.fb.control(this.user.school_id, Validators.required),
        cover: this.fb.control(''),
        name: this.fb.control(n, Validators.required),
        uid: this.fb.control(file.uid, Validators.required),
        // reserve3:  this.fb.control(-1),
        // url: this.fb.control(file.url, Validators.required),
        // suffix: this.fb.control(+course_id, Validators.required),
      };
      if ( this.bisType === 'audio') {
        // @ts-ignore
        fields['reserve3'] = this.fb.control(-1);
      }
      const item = this.fb.group(fields);

      if (file.size) {
        item.addControl('size', this.fb.control(file.size, Validators.required));
      }
      // @ts-ignore
      if (file?.response?.duration) {
        // @ts-ignore
        item.addControl('duration', this.fb.control(file?.response?.duration, Validators.required));
      }
      // @ts-ignore
      if (file?.response?.url) {
        // @ts-ignore
        item.addControl('url', this.fb.control(file?.response?.url, Validators.required));
        item.addControl('school_id', this.fb.control(this.user.school_id || 0));
        item.addControl('suffix', this.fb.control(this.getFileSuffix(file?.response?.url), Validators.required));
      }
      this._tmpFormItemArray.push(item);
      this._tmpFormItemArray.sort((a: UntypedFormGroup, b: UntypedFormGroup) => {
        const name1 = a.controls['name'].value.match(/\d+/g) ? a.controls['name'].value.match(/\d+/g).join('') : a.controls['name'].value;
        const name2 = b.controls['name'].value.match(/\d+/g) ? b.controls['name'].value.match(/\d+/g).join('') : b.controls['name'].value;
        return name1.localeCompare(name2);
      });
      this.itemsArray.clear();
      for (let i = 0; i < this._tmpFormItemArray.length; i++) {
        this.itemsArray.push(this._tmpFormItemArray[i]);
      }

      // this.itemsArray.push(item);
      // @ts-ignore
      // this.itemsArray.sort((a, b) => a.name.localeCompare(b.name));
      this.removeFile(file);

      this.nzMessageService.success(`${file.name} file uploaded successfully.`);
    } else if (status === 'error') {
      this.nzMessageService.error(`${file.name} file upload failed.`);
    }
  }

  getMediaFileDuration(url: string) {
    console.log('getMediaFileDuration')
    return new Promise<number>((resolve, reject) => {
      let a: HTMLAudioElement | HTMLVideoElement | null = null;
      if (this.bisType === 'video') {
        a = document.createElement('video');
        a.onerror = (e) => {
          console.error(e);
        };
        a.addEventListener('error', (evt: Event) => {
          console.error(evt);
        });
        a.controls = false;
        if ('width' in a) {
          a.width = 640;
        }
        if ('height' in a) {
          a.height = 360;
        }
        a.muted = true;
        a.style.display = 'none';
        const videoSource = document.createElement('source');
        videoSource.src = url;
        videoSource.type = 'video/mp4';

        a.appendChild(videoSource);
        document.body.appendChild(a);

      } else {
        a = new Audio();
        // @ts-ignore
        a!.src = url;
      }

      a!.preload = 'metadata';

      a!.addEventListener('error', (err) => {
        console.error(err);
        // a!.src = '';
        a!.remove();
        // @ts-ignore
        this.nzMessageService.error(err.message || `该${this.bisType === 'video' ? '视频' : '音频'}无法播放，请重新选择文件`);
        reject(err);
      });
      a!.addEventListener('loadedmetadata', () => {
        console.log('loadedmetadata');
        const duration = a!.duration; // the duration variable now holds the duration (in seconds) of the audio clip
        a!.preload = 'none';
        // a!.src = '';
        a!.remove();
        resolve(duration);
      });

    });

  }

  protected readonly UserStatus = UserStatus;
  protected readonly Boolean = Boolean;
  protected readonly JSON = JSON;
  protected readonly Object = Object;
  protected readonly Array = Array;
  protected readonly parseInt = parseInt;
  protected readonly Math = Math;
}
